export const COLORS = {
  white: "#ffffff",
  black: "#000000",
  grey: "grey",
  appHeaderBg: "#282c34",
  appLink: "#61dafb",
  selectedTabText: "#32CD32",
  selectedTabBackground: "#2d3e95",
  chartModalBorder: "#000000",
  highlightGold: "#FFD700",
  handBorder: "#eee",
  handSelectedBg: "#90EE90",
  correctRangeBg: "lightblue",
  incorrectRangeBg: "rgba(255, 0, 0, 0.3)",
  villainText: "#d32f2f",
  heroText: "#388e3c",
  situationText: "#1976d2",
  gradientPinkStart: "#FE6B8B",
  gradientPinkEnd: "#FF8E53",
  successGradientStart: "#66bb6a",
  successGradientEnd: "#43a047",
  borderGrey: "#ccc",
  pausedBackground: "rgba(0,0,0,0.02)",
  overlayWhite: "rgba(255, 255, 255, 0.9)",
  borderOverlay: "rgba(0, 0, 0, 0.12)",
  feedbackCorrectBg: "rgba(46, 125, 50, 0.8)",
  feedbackIncorrectBg: "rgba(211, 47, 47, 0.8)",
  pinkShadowLight: "rgba(255, 105, 135, .3)",
  pinkShadowDark: "rgba(255, 105, 135, .4)",
};
